exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dash-text[data-v-f5e611b6]{font-size: 16px;}\n.dash-text span[data-v-f5e611b6]{font-size: 17px;}\n.setting-btn[data-v-f5e611b6]{font-size: 17px;}\n.dash-icon[data-v-f5e611b6] {font-size: 21px;}\n", ""]);

// exports
